import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { DestinoItem } from "./item";
import { Destino } from "./model";
import { cancelarViajeApp, finalizarViajeApp, syncViaje, borrarViajeDeDispositivo } from "../logic";
import { onAgregarIncompleta, puedeAgregarIncompleta, onSincronizar } from "./logic";

import { EntregaIncompletaModelEdit, EntregaIncompletaModel } from "./incompleta";
interface Props {
    items: Destino[];
    value: models.ViajeAppIniciado;
    onChange: (x: models.ViajeAppIniciado) => Promise<void>;
    idViajeEAD: number;
}

interface State {
    busqueda: string;
}

const CancelarButton = kea.defaultProps(kea.Button, { children: "Cancelar viaje", style: "danger", iconClass: fa("times") });
const FinalizarButton = kea.defaultProps(kea.Button, { children: "Finalizar viaje", style: "success", iconClass: fa("check") });
const SincronizarButton = kea.defaultProps(kea.Button, { children: "Sincronizar", style: "default", iconClass: fa("refresh") });

/**Listado de los destinos */
export class DestinosList extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = { busqueda: "" };
    }

    modalManager = kea.createModalManager();

    busqueda = (props: Props, state: State) => state.busqueda;
    items = (props: Props, state: State) => props.items;
    itemsFiltrados = createSelectorRx(this.items, this.busqueda, (items, busqueda) =>
        items.filter(x => search(busqueda, x.NombreCliente + " " + x.Direccion.Descripcion))
    );

    onVerEntregas = async (x: Destino) => {
        history.go("./" + x.IdDireccionCliente);
    }
    onIncompleta = async (x: Destino) => {
        const validacion = puedeAgregarIncompleta(this.props.value, x.IdDireccionCliente);
        if (validacion != true) {
            switch (validacion) {
                case "tieneIncompleta":
                    await kea.message("Ya esta incompleta", "Este destino ya se marco como con entrega incompleta", "warning");
                    break;
                case "tieneRealizadas":
                    await kea.message("Tiene entregas realizadas", "No se puede marcar el destino como incompleto si ya tiene entregas realizadas ", "warning");
                    break;
                default: assertUnreachable(validacion);
            }
            return;
        }

        const inicial: EntregaIncompletaModel = { motivo: "" };
        const result = await this.modalManager.showModal(EntregaIncompletaModelEdit, undefined, inicial);
        if (result.result) {
            const value = result.value;
            const old = this.props.value;
            const next = onAgregarIncompleta(old, x.IdDireccionCliente, value.motivo);
            await this.props.onChange(next);
            const syncResult = await syncViaje();

            if (syncResult == true) {
                await kea.message("Destino incompleto", "Se compartieron los datos con el servidor", "success");
            } else {
                await kea.message("Destino incompleto, sin conexión", "Se almacenaron los datos en el dispositivo ya que no hay conexión", "warning");
            }
        }
    }

    onCancelarViaje = async () => {
        if (await kea.yesno("¿Cancelar el viaje?")) {
            //Antes de cancelar tratamos de sincronizar, esto por si hay datos en el cliente que impedirian la cancelación
            await syncViaje();
            const ret = await cancelarViajeApp();
            //TODO: Manejar mensajes de error
            await kea.message("Viaje cancelado");
        }
    }
    onFinalizarViaje = async () => {
        if (await kea.yesno("¿Finalizar viaje?")) {
            await finalizarViajeApp();
            //TODO: Manejar mensajes de error

            await kea.message("Viaje finalizado")
        }
    }

    onSincronizar = async () => {
        await onSincronizar();
    }

    onRegresar = () => {
        history.go("../");
    }

    render() {
        const items = this.itemsFiltrados(this.props, this.state);
        return (
            <div>
                <kea.Title titulo="Destinos del viaje de EAD" onRegresar={this.onRegresar} >
                </kea.Title>
                <div className="row">
                    <div className="col-md-2">
                        <kea.Number value={this.props.value.folioViajeEAD} label="Folio del Viaje EAD" readonly={true} />
                    </div>
                </div>

                <div className="btn-group">
                    <CancelarButton onClick={this.onCancelarViaje} />
                    <FinalizarButton onClick={this.onFinalizarViaje} />
                    <SincronizarButton onClick={this.onSincronizar} />
                </div>
                <kea.Text addon={<i className={fa("search")} />} placeholder="Búsqueda" value={this.state.busqueda} onChange={x => this.setState({ busqueda: x })} />
                {
                    items.map(x => <DestinoItem
                        key={x.IdDireccionCliente}
                        value={x}
                        onEntregaIncompleta={() => this.onIncompleta(x)}
                        onVerEntregas={() => this.onVerEntregas(x)}
                    />)
                }
                {this.modalManager.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/destinos/listmem.tsx